export const FETCH_HEALTH_TAGS_REQUEST = "FETCH_HEALTH_TAGS_REQUEST";
export const UPDATE_HEALTH_TAG_REQUEST = "UPDATE_HEALTH_TAG_REQUEST";
export const CREATE_HEALTH_TAG_REQUEST = "CREATE_HEALTH_TAG_REQUEST";
export const CHANGE_HEALTH_TAG_WEIGHT_REQUEST = "CHANGE_HEALTH_TAG_WEIGHT_REQUEST";
export const UPDATE_DOCTOR_HEALTH_TAG_REQUEST_SPECIALTY = "UPDATE_DOCTOR_HEALTH_TAG_REQUEST_SPECIALTY";
